import React from "react";
import { Avatar, Badge } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";

// Fallback avatars: initials on a colour picked from the name, so a person keeps one colour
const AVATAR_COLORS = [
  "#EA580C",
  "#7C3AED",
  "#4F46E5",
  "#059669",
  "#B45309",
  "#DB2777",
  "#2563EB",
  "#0D9488",
];

export const getAvatarColor = (name = "") => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) | 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

// "kunal.singh" / "Kunal Singh" -> "KS"; a single word gives one letter
export const getInitials = (name = "") => {
  const parts = name.trim().split(/[\s._-]+/).filter(Boolean);
  if (parts.length === 0) return "?";
  const first = parts[0].charAt(0);
  const last = parts.length > 1 ? parts[parts.length - 1].charAt(0) : "";
  return (first + last).toUpperCase();
};

const CustomAvatar = ({
  userName = "",
  img,
  size = 60,
  isServerImage = true,
  allowBadge = false,
  badgeFunction = () => {},
  reRenderDisableOnText = false,
}) => {
  // Helper to construct the server image URL
  const createImageURL = (pathname) =>
    `${"https://e-connect.elsner.com/public"}/${pathname}`;

  // Determine if the image is valid
  const imageSrc = img ? (isServerImage ? createImageURL(img) : img) : null;
  // Fallback to initials if no valid image
  const isImageValid = Boolean(img);

  return (
    <Badge
      className="avatar-img"
      onClick={() => badgeFunction()}
      count={
        <CloseCircleOutlined
          style={{
            color: "#f5222d",
            display: allowBadge && img ? "" : "none",
          }}
        />
      }
    >
      {!reRenderDisableOnText && (
        <Avatar
          key={userName}
          src={isImageValid ? imageSrc : undefined} // Only pass src if the image is valid
          alt={userName}
          size={size}
          style={
            isImageValid
              ? undefined
              : {
                  fontSize: Math.round(size * 0.36),
                  fontWeight: 600,
                  color: "#FFFFFF",
                  backgroundColor: getAvatarColor(userName),
                }
          }
        >
          {!isImageValid && getInitials(userName)}
        </Avatar>
      )}

      {reRenderDisableOnText && (
        <div
          className="custom-avatar"
          style={{
            width: size,
            height: size,
            fontSize: Math.round(size * 0.36),
            fontWeight: 600,
            backgroundColor: getAvatarColor(userName),
          }}
        >
          {getInitials(userName)}
        </div>
      )}
    </Badge>
  );
};

// Memoize the component with a custom comparison function
export default React.memo(CustomAvatar, (prevProps, nextProps) => {
  // Compare props to prevent unnecessary re-renders
  return (
    prevProps.img === nextProps.img &&
    prevProps.userName === nextProps.userName &&
    prevProps.size === nextProps.size &&
    prevProps.isServerImage === nextProps.isServerImage &&
    prevProps.allowBadge === nextProps.allowBadge &&
    prevProps.customInitial === nextProps.customInitial
  );
});
